
import {
   showPostModal,
   hideModal,
} from './modals';
import {
   removeIdFromQuery,
   idIntoQuery,
} from './utils/queryUtils';
import {Modal} from 'bootstrap';

const PRETTYQ = '/id/';

const $ = jQuery.noConflict();

window.lastId = false;


export function router(evt) {
   var postIDPrefix = '#id-';
   var hash = location.hash;

   var modalSelector = '*[data-modal-anchor="' + hash + '"]';
   var $modalContentModule = $(modalSelector);

   var pxPerSecond = 5000;

   if (hash.indexOf(postIDPrefix) == 0){
      if (evt){
         evt.preventDefault();	
      }
      var id = hash.replace(postIDPrefix, '');
      showPostModal(id);
   }
   else if ($modalContentModule.length){
      $modalContentModule.modal('show');
   }
   else {
      /* if (hash){
         var scrollTo = document.getElementById(hash.replace('#', ''));
         if (scrollTo){
				
            var offset;
            if (viewsPageOptions.scrollToSecton === 'false' || themeSettings.scroll_to_section === 'false'){
               offset = $(scrollTo).offset().top;
            }
            else{
               var parent = $(scrollTo).closest('section');
               offset = parent
                  ? $(parent).offset().top
                  : $(scrollTo).offset().top;
            }
            var dist = offset - $(document).scrollTop();
            var scrollTime = Math.abs(dist) / pxPerSecond;
            if (themeSettings.scroll_jump == "true"){
               scrollTime = 0;
            }
            $('html, body').animate({
               "scrollTop": offset + "px",
            }, scrollTime * 1000);
         }
      } */
   }
}

export function pathWithoutId(loc=false){
   let {
      protocol,
      hostname,
      pathname,
      search,
      hash,
   } = location;
   return `${pathname}${removeIdFromQuery(search)}`;
}

export function queryRouter(id, pushState, showModal){
   if (!id){
      return;
   }
	
   let prettyModalUrls = false;
   if (window.viewsPageOptions.prettyModalUrls === 'true'){
      prettyModalUrls = true;
   }

   var url = prettyModalUrls
      ? pathWithoutId() + PRETTYQ + id + location.hash
      : idIntoQuery(location.search, id) + location.hash;

   if (pushState){
      history.pushState(url, null, url);
   }
   try{
      if (addthis_share){
         addthis_share.url = location.href;
      }
   }
   catch(e){
      // no addthis_share
   }
   if (showModal !== false){
		const modalEl = document.getElementById('evtx-modal');
		const modal = Modal.getOrCreateInstance(modalEl);
		if (modal) {
			modal.show();
		}
		else {
			console.warn("Can't find evtx-modal element.");
		}
   }
   showPostModal(id);
}

export function routeByUrlQuery(){
   var id;
   if (location.search.indexOf('id=') >= 0){
      var queries = location.search.split('&');
      for (var i = 0; i < queries.length; i++){
         var pair = queries[i].split('=');
         if (pair[0] == 'id' || pair[0] == "?id"){
            id = pair[1];
         }
      }
      window.lastId = id;
      queryRouter(id, false);
   }
   else if (location.href.indexOf(PRETTYQ) >= 0){
      var loc = location.href.indexOf(PRETTYQ) + PRETTYQ.length;
      id = location.href.substring(loc);
      id = id.replace(/\//g, '');
      window.lastId = id;
      queryRouter(id, false);
   }
   else {
      if (window.lastId){
         hideModal(true);
      }
   }
}

export function setupRoutingEvents(){
   $(document).ready(function(){
      routeByUrlQuery();
   });

   window.onpopstate = function(event){
      routeByUrlQuery();
   };

   window.addEventListener("hashchange", router, false);

   // Browser state routing
   $(document).on("click", '[data-post-id]', function(event){
      var $this = $(this);
      event.preventDefault();
      event.stopPropagation();
      var postID = $this.attr('data-post-id');
      var isInModal = $this.closest('#evtx-modal').length > 0;
      queryRouter(postID, true, !isInModal);
   });

   // initialize hash link
   router();
}